var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectoryDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 179 179",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1-directory-default",
    cx: 83.5,
    cy: 83.5,
    r: 83.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.8%",
    y: "-4.8%",
    width: "112.0%",
    height: "112.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2-directory-default"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.733333333   0 0 0 0 0.733333333   0 0 0 0 0.733333333  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Data-Broker-Group-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Data-Brokers-Creation-8",
    transform: "translate(-1529.000000, -737.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-directories-new",
    transform: "translate(1533.000000, 741.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2-directory-default)",
    xlinkHref: "#path-1-directory-default"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1-directory-default"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_folder",
    transform: "translate(49.000000, 55.000000)",
    fill: "#1FA0FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3214706,16.5035294 L27.3161765,16.5035294 L24.0220588,10.2879412 C23.6322197,9.54293883 22.8617147,9.07524548 22.0208824,9.07314071 L3.07970588,9.07314071 C2.47192351,9.06768442 1.88741927,9.30667289 1.45763431,9.73645784 C1.02784936,10.1662428 0.788860892,10.750747 0.794317185,11.3585294 L0.794317185,54.3652941 C0.788860892,54.9730765 1.02784936,55.5575807 1.45763431,55.9873657 C1.88741927,56.4171506 2.47192351,56.6561391 3.07970588,56.6506828 L57.3173529,56.6506828 C57.9251353,56.6561391 58.5096395,56.4171506 58.9394245,55.9873657 C59.3692095,55.5575807 59.6081979,54.9730765 59.6027416,54.3652941 L59.6027416,18.7888235 C59.5925697,17.5308883 58.5752882,16.5136068 57.3173529,16.5035294 L57.3214706,16.5035294 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3926471,7.43029412 L32.8152941,7.43029412 L29.5211765,1.21470588 C29.1313373,0.469703539 28.3608323,0.0020101906 27.52,0 L10.6685294,0 C9.40639632,0 8.38323529,1.02316103 8.38323529,2.28529412 C8.38323529,3.54742721 9.40639632,4.57058824 10.6685294,4.57058824 L26.1714706,4.57058824 L29.4655882,10.7861765 C29.8554274,11.5311788 30.6259324,11.9988722 31.4667647,12.0008824 L64.1732353,12.0008824 L64.1732353,46.795 C64.1732352,47.611457 64.6088098,48.3658944 65.3158823,48.7741229 C66.0229548,49.1823514 66.894104,49.1823514 67.6011765,48.7741229 C68.308249,48.3658944 68.7438235,47.611457 68.7438235,46.795 L68.7438235,9.71558824 C68.6763232,8.4546816 67.6488647,7.45863012 66.3864706,7.43029412 L66.3926471,7.43029412 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectoryDefault);
export default __webpack_public_path__ + "static/media/directory-default.b7e55b6d8e158c0401f018653e1339b6.svg";
export { ForwardRef as ReactComponent };